'use client';

import { useEffect } from 'react';
import { useFormatPrefsStore } from '@/shared/stores/format-prefs-store';
import { setNumberLocale } from '@/shared/utils/number-format';

/**
 * Aplică locale-ul de numere (din `useFormatPrefsStore`) în helper-ul
 * `number-format` și forțează re-randarea subtree-ului la schimbarea
 * preferinței prin `key={numberFormat}` (toggle rar în setări → remount
 * controlat al conținutului).
 *
 * `setNumberLocale` se apelează SINCRON la fiecare randare (nu doar în
 * useEffect) ca `activeLocale` să fie corect ÎNAINTE ca descendenții să
 * randeze numere. Apelul e idempotent (doar setează o variabilă de modul).
 */
export function NumberFormatProvider({ children }: { children: React.ReactNode }) {
  const numberFormat = useFormatPrefsStore((s) => s.numberFormat);

  // Sincron: descendenții randează cu locale-ul corect din prima.
  setNumberLocale(numberFormat);

  // Defensiv pentru cod care rulează după mount / în alt frame.
  useEffect(() => {
    setNumberLocale(numberFormat);
  }, [numberFormat]);

  return (
    <div key={numberFormat} style={{ display: 'contents' }}>
      {children}
    </div>
  );
}
